<script lang="ts">
  import Svg from "./Svg.svelte"
  /**
   * This component has customizable attributes of SVG icons.
   * We can use SVG icons in a better way inside other Svelte components like so:
   * --------------------------------------------------------------------------
   * import Icon from "../Components/Icon.svelte"
   */

  /** defines attributes that should svg have  */
  export let svgProps: {
    fill: string
    data: string
    alt: string
  }

  /** size of the icon */
  export let size: string

  /** width of the icon, by default taken from the size */
  export let width: string = size

  /** height of the icon, by default taken from the size */
  export let height: string = size

  /** background color of the icons */
  export let backgroundColor: string = "transparent"
</script>

<!-- Assign size attribute as a class name for further styling in the CSS -->
<div
  class="auws-icon"
  style="--background-color: {backgroundColor}; --width: {size}; --height: {size}"
>
  <Svg {width} {height} {...svgProps} />
</div>

<style>
  .auws-icon {
    padding: 10px;
    border-radius: 50%;
    background-color: var(--background-color);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    cursor: pointer;
    height: var(--height);
    width: var(--width);
    box-sizing: border-box;
  }
</style>
